<template>
    <div class="container">
        <div v-for="(item, index) in mediaList" :key="index" style="margin: 0px 20px;">
            <img :src="item.url" alt="" v-if="item.display" @click="goToShare(item.redirectUrl)">
        </div>
    </div>
</template>

<script setup lang="ts">
import { goToShare, MediaItem } from '@/view/home/supportScript';
import { ref, defineProps, onMounted } from 'vue';

const props = defineProps<{
    itemData: {
        shareMediaList: MediaItem[]
    }
}>()
const mediaList = ref(props.itemData.shareMediaList)

onMounted(() => {
    mediaList.value = props.itemData.shareMediaList
})
</script>
<style scoped>
.container {
    display: flex;
    justify-content: center;
    padding: 8px 10px;
    background: #ffa54314;
    border-radius: 9px;
}

.container img {
    width: 55px;
}

@media screen and (max-width: 768px) {
    .container img {
        width: 60px;
    }
}

@media screen and (max-width: 400px) {
    .container img {
        width: 40px;
    }
}
</style>